import { GuideLink } from 'components/OverviewComponents'
import Grid from 'ds/Grid'
import React from 'react'
import ObsAPI from '../../assets/obs-api.png'
import ObsCuratedDashboards from '../../assets/obs-curated-dashboards.png'
import ObsCustomDashboards from '../../assets/obs-custom-dashboards.png'

const guideLinkData = [
	{
		title: 'Curated Dashboards',
		description:
			'Primer’s curated Dashboards give merchants easy access to all the payment metrics they need to optimize their payments stack effectively.',
		link: '/observability/curated-dashboards',
		imgSrc: ObsCuratedDashboards,
	},
	{
		title: 'Custom Dashboards',
		description:
			'Business intelligence isn’t one-size-fits-all, so we enable you to build custom dashboards that track your key metrics.',
		link: '/observability/custom-dashboards',
		imgSrc: ObsCustomDashboards,
	},
]

export default function GuideLinks({ oneRow = false }) {
	return (
		<Grid cols={oneRow ? { sm: 1, md: 3, lg: 3, xl: 3 } : { md: 1, lg: 2, xl: 2 }} gap={24} style={{ marginTop: 24 }}>
			{guideLinkData.map(guide => (
				<GuideLink
					key={guide.title}
					title={guide.title}
					description={guide.description}
					link={guide.link}
					imgSrc={guide.imgSrc}
				/>
			))}
		</Grid>
	)
}
